export function InfoItem({
    label,
    value,
}: {
    label: string;
    value?: string | number | null;
}) {
    return (
        <div>
            <p className="text-xs text-muted-foreground">
                {label}
            </p>

            <p className="text-sm font-medium">
                {value || "No registrado"}
            </p>
        </div>
    );
}
